// @ts-strict-ignore
import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Element, Section } from 'src/constants/footfall';
import i18n from 'src/utils/translate';
import FollowButton from 'src/components/buttons/followButton/followButton';
import { LinkButton } from 'styles-js/buttons';
import { helpScoutReportForm } from 'src/utils/helpScoutBeacon';
import ProfileButtonNewChat from 'src/modules/user/profile/components/profileButtonNewChat';
export default function ButtonsPanel() {
  const currentUserUsername = useSelector(({
    context
  }) => context.currentUser?.username);
  const {
    isOwnProfile,
    isFollowedByCurrentUser,
    isUserFollowsEnabled,
    userId,
    username
  } = useSelector(({
    pages
  }) => pages.profile.profileUser);
  const OnReportClick = () => {
    trackFootfallEvent(Event.Clicked, {
      clickType: 'report',
      clickMetadata: {
        section: Section.ProfileHeader
      }
    });
    helpScoutReportForm({
      name: currentUserUsername,
      subject: i18n.t('Report profile'),
      text: i18n.t('Why do you want to report this profile?')
    });
  };
  if (isOwnProfile) return null;
  return <ButtonsWrapper data-sentry-element="ButtonsWrapper" data-sentry-component="ButtonsPanel" data-sentry-source-file="profileButtonsPanel.tsx">
      <ProfileButtonNewChat data-sentry-element="ProfileButtonNewChat" data-sentry-source-file="profileButtonsPanel.tsx" />
      {isUserFollowsEnabled && <StyledFollowButton clickMetadata={{
      element: Element.Follow,
      section: Section.PublicProfile
    }} dataTestId="profile__follow_button" followText={i18n.t('Follow')} followType="user" hasIcon={isFollowedByCurrentUser} isFollowing={isFollowedByCurrentUser} userId={userId} username={username} onFollowClick={() => trackFootfallEvent(Event.Clicked, {
      clickMetadata: {
        section: Section.ProfileHeader,
        element: 'follow-button',
        origin: isOwnProfile ? 'own-profile' : 'other-profile'
      },
      clickType: isFollowedByCurrentUser ? 'unfollow' : 'follow'
    })} />}
      <LinkButton data-testid="profile__report_button" onClick={OnReportClick} data-sentry-element="LinkButton" data-sentry-source-file="profileButtonsPanel.tsx">{i18n.t('Report')}</LinkButton>
    </ButtonsWrapper>;
}
const ButtonsWrapper = styled.div`
  display: flex;
  align-items: stretch;
  gap: 10px;
  @media (${({
  theme
}) => theme.overScreenSmall}) {
    margin-left: auto;
  }
`;
const StyledFollowButton = styled(FollowButton)`
  width: ${({
  isFollowing: isFollowing
}) => isFollowing ? '120px' : '110px'};
  @media (${({
  theme
}) => theme.underScreenSmall}) {
    width: ${({
  isFollowing: isFollowing
}) => isFollowing ? '120px' : '100px'};
  }
`;